import { BASE_URL } from '../../../Constant';

export const API_GET_ALL_SUCCESS_DOCUMENTS: string = `${BASE_URL}/document/created`;
export const API_SEND_DOCUMENT_EMAIL: string = `${BASE_URL}/document/sendEmail`;
